import React, {Component} from "react";

class FilterBase extends Component {
    render = () => this.renderContent();
    renderContent = () => undefined;
}


export default FilterBase;
